export default __webpack_public_path__ + "static/media/bbq.8ea65ca6.png";